module.exports = __webpack_public_path__ + "img/linkedin.94be2093.svg";